function getPropertyDescriptor(constructor: Function, name: string):
		PropertyDescriptor {

	for (let proto = constructor.prototype; proto;
				proto = Object.getPrototypeOf(proto)) {
		let pd = Object.getOwnPropertyDescriptor(proto, name);
		if (pd) {
			if (name === "createdCallback") {
				// work around not allowing local let to be closed over in a for loop
				(function(pd: any, oldFunction: any) {
					pd.value = function() {
						constructor.call(this);
						oldFunction.call(this);
					};
				})(pd, pd.value);

			}
			return pd;
		}
	}
	return undefined;
}

function getPropertyNames(constructor: Function): string[] {
	const result: string[] = [];
	for (let proto = constructor.prototype;
				proto && proto !== CustomElement.prototype;
				proto = Object.getPrototypeOf(proto)) {
		Object.getOwnPropertyNames(proto).forEach((property) => {
			if (result.indexOf(property) === -1)
				result.push(property);
		});
	}
	return result;
}

// Public Definitions -------------------------------------------------------->

export class CustomElement implements HTMLElement, HTMLImageElement {
	childElementCount: number;
	firstElementChild: Element;
	lastElementChild: Element;
	nextElementSibling: Element;
	previousElementSibling: Element;
	attributes: NamedNodeMap;
	baseURI: string;
	childNodes: NodeList;
	firstChild: Node;
	lastChild: Node;
	localName: string;
	namespaceURI: string;
	nextSibling: Node;
	nodeName: string;
	nodeType: number;
	nodeValue: string;
	ownerDocument: Document;
	parentElement: HTMLElement;
	parentNode: Node;
	prefix: string;
	previousSibling: Node;
	textContent: string;
	ATTRIBUTE_NODE: number;
	CDATA_SECTION_NODE: number;
	COMMENT_NODE: number;
	DOCUMENT_FRAGMENT_NODE: number;
	DOCUMENT_NODE: number;
	DOCUMENT_POSITION_CONTAINED_BY: number;
	DOCUMENT_POSITION_CONTAINS: number;
	DOCUMENT_POSITION_DISCONNECTED: number;
	DOCUMENT_POSITION_FOLLOWING: number;
	DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC: number;
	DOCUMENT_POSITION_PRECEDING: number;
	DOCUMENT_TYPE_NODE: number;
	ELEMENT_NODE: number;
	ENTITY_NODE: number;
	ENTITY_REFERENCE_NODE: number;
	NOTATION_NODE: number;
	PROCESSING_INSTRUCTION_NODE: number;
	TEXT_NODE: number;

	flippInert: boolean;

	classList: DOMTokenList;
	clientHeight: number;
	clientLeft: number;
	clientTop: number;
	clientWidth: number;
	msContentZoomFactor: number;
	msRegionOverflow: string;
	accessKey: string;
	children: HTMLCollection;
	contentEditable: string;
	dataset: DOMStringMap;
	dir: string;
	draggable: boolean;
	hidden: boolean;
	hideFocus: boolean;
	innerHTML: string;
	readonly assignedSlot: HTMLSlotElement | null;
	slot: string;
	readonly shadowRoot: ShadowRoot | null;
	innerText: string;
	isContentEditable: boolean;
	lang: string;
	offsetHeight: number;
	offsetLeft: number;
	offsetParent: Element;
	offsetTop: number;
	offsetWidth: number;
	scrollHeight: number;
	scrollLeft: number;
	scrollTop: number;
	scrollWidth: number;
	tagName: string;
	id: string;
	className: string;
	outerHTML: string;
	outerText: string;
	spellcheck: boolean;
	style: CSSStyleDeclaration;
	tabIndex: number;
	title: string;
	align: string;
	alt: string;
	border: string;
	lowsrc: string;
	complete: boolean;
	crossOrigin: string;
	currentSrc: string;
	height: number;
	hspace: number;
	isMap: boolean;
	longDesc: string;
	msPlayToDisabled: boolean;
	msPlayToPreferredSourceUri: string;
	msPlayToPrimary: boolean;
	msPlayToSource: any;
	name: string;
	naturalHeight: number;
	naturalWidth: number;
	src: string;
	sizes: string;
	srcset: string;
	useMap: string;
	vspace: number;
	width: number;
	x: number;
	y: number;

	onabort: (ev: Event) => any;
	onactivate: (ev: UIEvent) => any;
	onbeforeactivate: (ev: UIEvent) => any;
	onbeforecopy: (this: HTMLElement, ev: ClipboardEvent) => any;
	onbeforecut: (this: HTMLElement, ev: ClipboardEvent) => any;
	onbeforedeactivate: (ev: UIEvent) => any;
	onbeforepaste: (this: HTMLElement, ev: ClipboardEvent) => any;
	onblur: (ev: FocusEvent) => any;
	oncanplay: (ev: Event) => any;
	oncanplaythrough: (ev: Event) => any;
	onchange: (ev: Event) => any;
	onclick: (ev: MouseEvent) => any;
	oncontextmenu: (ev: PointerEvent) => any;
	oncopy: (this: HTMLElement, ev: ClipboardEvent) => any;
	oncuechange: (ev: Event) => any;
	oncut: (this: HTMLElement, ev: ClipboardEvent) => any;
	ondblclick: (ev: MouseEvent) => any;
	ondeactivate: (ev: UIEvent) => any;
	ondrag: (ev: DragEvent) => any;
	ondragend: (ev: DragEvent) => any;
	ondragenter: (ev: DragEvent) => any;
	ondragleave: (ev: DragEvent) => any;
	ondragover: (ev: DragEvent) => any;
	ondragstart: (ev: DragEvent) => any;
	ondrop: (ev: DragEvent) => any;
	ondurationchange: (ev: Event) => any;
	onemptied: (ev: Event) => any;
	onended: (ev: Event) => any;
	onerror: (ev: Event) => any;
	onfocus: (ev: FocusEvent) => any;
	oninput: (ev: Event) => any;
	oninvalid: (this: HTMLElement, ev: Event) => any;
	onkeydown: (ev: KeyboardEvent) => any;
	onkeypress: (ev: KeyboardEvent) => any;
	onkeyup: (ev: KeyboardEvent) => any;
	onload: (ev: Event) => any;
	onloadeddata: (ev: Event) => any;
	onloadedmetadata: (ev: Event) => any;
	onloadstart: (ev: Event) => any;
	onmousedown: (ev: MouseEvent) => any;
	onmouseenter: (ev: MouseEvent) => any;
	onmouseleave: (ev: MouseEvent) => any;
	onmousemove: (ev: MouseEvent) => any;
	onmouseout: (ev: MouseEvent) => any;
	onmouseover: (ev: MouseEvent) => any;
	onmouseup: (ev: MouseEvent) => any;
	onmousewheel: (ev: MouseWheelEvent) => any;
	onmscontentzoom: (ev: UIEvent) => any;
	onmsmanipulationstatechanged: (ev: MSManipulationEvent) => any;
	onpaste: (this: HTMLElement, ev: ClipboardEvent) => any;
	onpause: (ev: Event) => any;
	onplay: (ev: Event) => any;
	onplaying: (ev: Event) => any;
	onprogress: (ev: ProgressEvent) => any;
	onratechange: (ev: Event) => any;
	onreset: (ev: Event) => any;
	onscroll: (ev: UIEvent) => any;
	onseeked: (ev: Event) => any;
	onseeking: (ev: Event) => any;
	onselect: (ev: UIEvent) => any;
	onselectstart: (ev: Event) => any;
	onstalled: (ev: Event) => any;
	onsubmit: (ev: Event) => any;
	onsuspend: (ev: Event) => any;
	ontimeupdate: (ev: Event) => any;
	onvolumechange: (ev: Event) => any;
	onwaiting: (ev: Event) => any;
	onariarequest: (ev: Event) => any;
	oncommand: (ev: Event) => any;
	ongotpointercapture: (ev: PointerEvent) => any;
	onlostpointercapture: (ev: PointerEvent) => any;
	onmsgesturechange: (ev: MSGestureEvent) => any;
	onmsgesturedoubletap: (ev: MSGestureEvent) => any;
	onmsgestureend: (ev: MSGestureEvent) => any;
	onmsgesturehold: (ev: MSGestureEvent) => any;
	onmsgesturestart: (ev: MSGestureEvent) => any;
	onmsgesturetap: (ev: MSGestureEvent) => any;
	onmsgotpointercapture: (ev: MSPointerEvent) => any;
	onmsinertiastart: (ev: MSGestureEvent) => any;
	onmslostpointercapture: (ev: MSPointerEvent) => any;
	onmspointercancel: (ev: MSPointerEvent) => any;
	onmspointerdown: (ev: MSPointerEvent) => any;
	onmspointerenter: (ev: MSPointerEvent) => any;
	onmspointerleave: (ev: MSPointerEvent) => any;
	onmspointermove: (ev: MSPointerEvent) => any;
	onmspointerout: (ev: MSPointerEvent) => any;
	onmspointerover: (ev: MSPointerEvent) => any;
	onmspointerup: (ev: MSPointerEvent) => any;
	ontouchcancel: (ev: TouchEvent) => any;
	ontouchend: (ev: TouchEvent) => any;
	ontouchmove: (ev: TouchEvent) => any;
	ontouchstart: (ev: TouchEvent) => any;
	onwebkitfullscreenchange: (ev: Event) => any;
	onwebkitfullscreenerror: (ev: Event) => any;

	onpointercancel: (ev: PointerEvent) => any;
	onpointerdown: (ev: PointerEvent) => any;
	onpointerenter: (ev: PointerEvent) => any;
	onpointerleave: (ev: PointerEvent) => any;
	onpointermove: (ev: PointerEvent) => any;
	onpointerout: (ev: PointerEvent) => any;
	onpointerover: (ev: PointerEvent) => any;
	onpointerup: (ev: PointerEvent) => any;
	onwheel: (ev: WheelEvent) => any;

	remove(): void {}
	querySelector(selectors: string): Element { return undefined; }
	querySelectorAll(selectors: string): NodeListOf<Element> { return undefined; }
	dispatchEvent(evt: Event): boolean { return undefined; }
	removeEventListener(type: string, listener: EventListenerOrEventListenerObject, useCapture?: boolean): void {}
	appendChild<T extends Node>(newChild: T): T { return undefined; }
	cloneNode(deep?: boolean): Node { return undefined; }
	compareDocumentPosition(other: Node): number { return undefined; }
	hasAttributes(): boolean { return undefined; }
	hasChildNodes(): boolean { return undefined; }
	closest(selector: string): Element | null { return undefined; }
	insertBefore<T extends Node>(newChild: T, refChild: Node | null): T { return undefined; }
	isDefaultNamespace(namespaceURI: string): boolean { return undefined; }
	isEqualNode(arg: Node): boolean { return undefined; }
	isSameNode(other: Node): boolean { return undefined; }
	lookupNamespaceURI(prefix: string): string { return undefined; }
	lookupPrefix(namespaceURI: string): string { return undefined; }
	normalize(): void {}
	removeChild<T extends Node>(oldChild: T): T { return undefined; }
	replaceChild<T extends Node>(newChild: Node, oldChild: T): T { return undefined; }
	getAttribute(name?: string): string { return undefined; }
	getAttributeNS(namespaceURI: string, localName: string): string { return undefined; }
	getAttributeNode(name: string): Attr { return undefined; }
	getAttributeNodeNS(namespaceURI: string, localName: string): Attr { return undefined; }
	getBoundingClientRect(): ClientRect { return undefined; }
	getClientRects(): ClientRectList { return undefined; }
	getElementsByTagName(name: string): NodeListOf<Element> { return undefined; }
	getElementsByTagNameNS(namespaceURI: "http://www.w3.org/1999/xhtml", localName: string): HTMLCollectionOf<HTMLElement>;
	getElementsByTagNameNS(namespaceURI: "http://www.w3.org/2000/svg", localName: string): HTMLCollectionOf<SVGElement>;
	getElementsByTagNameNS(namespaceURI: string, localName: string): HTMLCollectionOf<Element> { return undefined; }
	hasAttribute(name: string): boolean { return undefined; }
	hasAttributeNS(namespaceURI: string, localName: string): boolean { return undefined; }
	msGetRegionContent(): MSRangeCollection { return undefined; }
	msGetUntransformedBounds(): ClientRect { return undefined; }
	msMatchesSelector(selectors: string): boolean { return undefined; }
	matches(selectors: string): boolean { return undefined; }
	msReleasePointerCapture(pointerId: number): void {}
	msSetPointerCapture(pointerId: number): void {}
	msZoomTo(args: MsZoomToOptions): void {}
	releasePointerCapture(pointerId: number): void {}
	removeAttribute(name?: string): void {}
	removeAttributeNS(namespaceURI: string, localName: string): void {}
	removeAttributeNode(oldAttr: Attr): Attr { return undefined; }
	requestFullscreen(): void {}
	requestPointerLock(): void {}
	setAttribute(name?: string, value?: string): void {}
	setAttributeNS(namespaceURI: string, qualifiedName: string, value: string): void {}
	setAttributeNode(newAttr: Attr): Attr { return undefined; }
	setAttributeNodeNS(newAttr: Attr): Attr { return undefined; }
	setPointerCapture(pointerId: number): void {}
	webkitMatchesSelector(selectors: string): boolean { return undefined; }
	webkitRequestFullScreen(): void {}
	webkitRequestFullscreen(): void {}
	getElementsByClassName(classNames: string): NodeListOf<Element> { return undefined; }
	addEventListener(type: string, listener: EventListenerOrEventListenerObject, useCapture?: boolean): void {}
	blur(): void {}
	click(): void {}
	contains(child: HTMLElement): boolean { return undefined; }
	dragDrop(): boolean { return undefined; }
	focus(): void {}
	insertAdjacentElement(position: string, insertedElement: Element): Element { return undefined; }
	insertAdjacentHTML(where: string, html: string): void {}
	insertAdjacentText(where: string, text: string): void {}
	msGetInputContext(): MSInputMethodContext { return undefined; }
	scrollIntoView(arg?: boolean | ScrollIntoViewOptions): void {}
	scroll(options?: ScrollToOptions): void;
	scroll(x?: number, y?: number): void;
	scroll(arg?: ScrollToOptions | number, y?: number): void {}
	scrollTo(options?: ScrollToOptions): void;
	scrollTo(x?: number, y?: number): void;
	scrollTo(arg?: ScrollToOptions | number, y?: number): void {}
	scrollBy(options?: ScrollToOptions): void;
	scrollBy(x?: number, y?: number): void;
	scrollBy(arg?: ScrollToOptions | number, y?: number): void {}
	setActive(): void {}
	attachShadow(shadowRootInitDict: ShadowRootInit): ShadowRoot { return undefined; }
	msGetAsCastingSource(): any {}
}

// Decorator factory that registers the given class as a custom element.
export function element(name: string, extension?: string) {
	return function<TFunction extends Function>(target: TFunction): TFunction {
		// Collect the property descriptors of the target.
		const descriptorMap = getPropertyNames(target).reduce(
			(acc: PropertyDescriptorMap, k: string) => {
				acc[k] = getPropertyDescriptor(target, k);
				return acc;
			}, <PropertyDescriptorMap>{});

		// Provide a default createdCallback that calls the target's constructor.
		if (!descriptorMap["createdCallback"]) {
			descriptorMap["createdCallback"] = {
				value: function() {
					target.call(this);
				}
			};
		}

		// Create a new prototype that derives from an HTMLElement
		// (inferred from extension if provided) and adds the methods
		// and properties of target.
		const base = extension ?
				Object.getPrototypeOf(document.createElement(extension)) :
				HTMLElement.prototype;
		const proto = Object.create(base, descriptorMap);

		// Register the custom element and return the new constructor to replace
		// the original one.
		let ctor = document.registerElement<TFunction>(name, extension ? {
			prototype: proto,
			extends: extension
		} : {
			prototype: proto
		});

		// Attach the tag name, so jsx createElement with named component knows
		// how to construct it.
		(<any> ctor).tagName = name;
		(<any> ctor).extends = extension;
		return ctor;
	};
}
